// eslint-disable-next-line no-redeclare
import { Location } from '@angular/common';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IBreadcrumb } from '@app/shared/services/breadcrumb.service';
import idx from '../lib/idx';
import { EnvironmentHelperService } from './environment-helper.service';

/** ? */
@Injectable()
export class CommunicatorService {
  public appRunningInIframe = true;

  constructor(
    public location: Location,
    private readonly router: Router,
    private readonly envHelper: EnvironmentHelperService
  ) {
    window.addEventListener('message', this.messageHandler.bind(this));
    this.appRunningInIframe = this.envHelper.isIframed;
  }

  public messageHandler(message: any): void {
    let data;

    try {
      data = JSON.parse(message.data);
    } catch {
      data = message.data;
    }

    try {
      if (idx(message, () => message.source.document.location.pathname) === this.router.url) {
        if (idx(data, () => data.type)) {
          if (!data.type.match(/:/)) {
            data.type = `postMessage:${<string>data.type}`;
          } else if (data.type === 'directory:route:changed') {
            this.handleDirectoryChanges(data);

            return;
          } else {
            let output = {
              type: data.type,
              data: data.data
            };
            let ee = new EventEmitter();
            ee.emit(output);
          }
        }
      } else {
        return;
      }
    } catch (e) {
      if (e.name === 'SecurityError') {
        return;
      }
      console.error('communication error', e);
    }
  }

  public target(): WindowProxy {
    /*
      3 cases:
      1. I am the content window and my parent is me
      2. I am the content window and my parent is the menu
      3. I am the menu window and I have content. I MIGHT be a child of directory
    */

    // Menu
    if (parent instanceof Window) {
      if (document.getElementById('iFrame#content')) {
        return document.getElementById('iFrame#content')[0].contentWindow;
      }
    }

    // I am content window
    return window.parent;
  }

  public routeChangeSuccess(hash: any, title: any): void {
    this.sendMessage('content:route:changed', { hash, title });
  }

  public breadcrumbChanged(breadcrumbs: IBreadcrumb[]): void {
    if (!breadcrumbs.length) {
      return;
    }

    breadcrumbs.forEach((crumb) => {
      Object.assign(crumb, { hash: crumb.url, label: crumb.label, value: crumb.label });
    });

    this.sendMessage('content:adminui:breadcrumbs:changed', breadcrumbs);
  }

  public toast({ message, type, hideAfter = 2 }: any): void {
    this.sendMessage('toast', { message, type, hideAfter });
  }

  public requestEngageNavTree(): void {
    this.sendMessage('request:engageNavTree');
  }

  private sendMessage(type: any, data: any = {}): void {
    this.target().postMessage({ type, data }, document.location.origin);

    return;
  }

  // handle postMessages from Directory regarding route changes
  private handleDirectoryChanges(data: any): void {
    let routeType = idx(data, (d) => data.data.routeType);
    let routeId: string = idx(data, (d) => data.data.routeId);

    if (routeType === 'group') {
      // subscribe to route
      this.location.go(`/directory/groups/${routeId}`);
    }
  }
}
